import React, { useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Table } from "react-bootstrap";
import { CommissionHistoryActions } from "../../redux";
import BasicPagination from "../../../pagination/BasicPagination";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";

const CommissionHistoryTable = ({ onEditClick }) => {
  const { isLoading, commissionHistoryList, skip, limit } = useSelector(
    (state) => state.commissionHistory,
    shallowEqual
  );

  const dispatch = useDispatch();

  //on page change
  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : skip;
    dispatch(CommissionHistoryActions.setVirtualTokenBatchNumber(count));
  };

  return (
    <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
      <div className="tblmrgn mt-0">
        <div className="mt-5">
          <div>
            <Table
              hover
              responsive
              className="mb-0 default_table with_hoverbtn mrpdng_tbl"
            >
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>User Name</th>
                  <th>Commission Type</th>
                  <th>Total Amount</th>
                  <th>Commission Earned</th>
                  <th>Commission Rate(%)</th>
                  <th>Bet Id</th>
                  <th>Created At</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {commissionHistoryList.data &&
                commissionHistoryList.data.commissionHistoryList.length ? (
                  commissionHistoryList.data.commissionHistoryList.map(
                    (commissionHistoryLists, index) => (
                      <tr key={index}>
                        <td>
                          <span className="f-w-500">
                            {skip * limit + (index + 1)}
                          </span>
                        </td>
                        <td>
                          <span>{commissionHistoryLists.userName}</span>
                        </td>
                        <td>{commissionHistoryLists.commission_type}</td>
                        <td>
                          {commissionHistoryLists.amount +
                            commissionHistoryLists.deduction_amount}
                        </td>
                        <td>{commissionHistoryLists.deduction_amount}</td>

                        <td>{commissionHistoryLists.percentage}%</td>
                        <td>
                          {" "}
                          <a
                            style={{ color: "#fff" }}
                            href={`/bet-management/bet-result-details/${commissionHistoryLists.bet_id}`}
                            target="_blank"
                          >
                            {commissionHistoryLists.bet_id}
                          </a>
                        </td>

                        <td>
                          {commissionHistoryLists?.createdAt
                            ? moment(commissionHistoryLists.createdAt).format(
                                "MMM Do YYYY, h:mm:ss a"
                              )
                            : "-"}
                        </td>
                        <td>
                          <a
                            title="View"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                            href={`/commission-history/commission-history-details/${commissionHistoryLists?._id}`}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/custom/eye.svg"
                                )}
                              />
                            </span>
                          </a>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan={10} className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
                {isLoading && (
                  <tr>
                    <td colSpan={10} className="text-center">
                      <div className="basic-verification-loader text-center">
                        <CircularProgress />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="row d-flex align-items-center mr-5 ml-5 mt-4 btm-pagination">
            <div className="col-md-4 mb-5 fn_s_16 f-w-400 text-left">
              Displaying {skip * limit + 1} - {skip * limit + limit} of{" "}
              {commissionHistoryList?.data?.count} Records
            </div>
            <div className="col-md-8 text-left mb-5 aspgntn">
              <BasicPagination
                totalRecords={commissionHistoryList?.data?.count}
                limit={limit}
                batch={skip + 1}
                onBatchChange={onPageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommissionHistoryTable;
